import { User } from '@/types/app_types';
import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface AuthState {
  user: User | null;
  isLoggedIn: boolean;
  isProfileFetching: boolean;
  isProfileFetched: boolean;
  setUser: (user: User | null) => void;
  clearUser: () => void;
  setProfileFetching: (fetching: boolean) => void;
  setProfileFetched: (fetched: boolean) => void;
}

export const useAuthStore = create<AuthState>()(
  persist(
    set => ({
      user: null,
      isLoggedIn: false,
      isProfileFetching: false,
      isProfileFetched: false,

      setUser: user =>
        set({
          user,
          isLoggedIn: !!user,
          isProfileFetched: !!user,
        }),

      clearUser: () =>
        set({
          user: null,
          isLoggedIn: false,
          isProfileFetching: false,
          isProfileFetched: false,
        }),

      setProfileFetching: fetching => set({ isProfileFetching: fetching }),

      setProfileFetched: fetched => set({ isProfileFetched: fetched }),
    }),
    {
      name: 'auth-storage', // localStorage key
      partialize: state => ({
        user: state.user,
        isLoggedIn: state.isLoggedIn,
        isProfileFetched: state.isProfileFetched,
        // isProfileFetching은 저장하지 않음 (항상 false로 시작)
      }),
    },
  ),
);
